import Lang, { IStrings, select, format, selectByPrefix } from "../../../common/utils/LanguageManager";
import pl from "./lang/pl";
import en from "./lang/en";
import de from "./lang/de";
import es from "./lang/es";

const strings: IStrings = {
	pl: pl,
	en: en,
	de: de,
	es: es,
}

export default {
	tooLongDescriptionError: (label: string) => Lang("tooLongDescriptionError", strings).replace("{0}", label),
	retypePasswordError: () => Lang("retypePasswordError", strings),
	fieldIsRequiredError: (label: string) => Lang("fieldIsRequiredError", strings).replace("{0}", label),

	permissionLevelRequiredError: () => Lang("permissionLevelRequiredError", strings),
	addToIssue: () => Lang("addToIssue", strings),
	dataSets: () => Lang("addToIssue", strings),
	businessProcesses: () => Lang("businessProcesses", strings),
	resource: () => Lang("resource", strings),
	period: () => Lang("period", strings),
	authorizationLevel: () => Lang("authorizationLevel", strings),

	currentAuthorizations: () => Lang("currentAuthorizations", strings),

	warningEmployeeChangeTitle: () => Lang("warningEmployeeChangeTitle", strings),
	warningEmployeeChangeText: (label: string) => Lang("warningEmployeeChangeText", strings).replace("{0}", label),
	selectEmployee: () => Lang("selectEmployee", strings),

	authorizationControlHasChanges: () => Lang("authorizationControlHasChanges", strings),

	editing: () => Lang("editing", strings),
	copying: () => Lang("copying", strings),
	copy: () => Lang("copy", strings),
	accept: () => Lang("accept", strings),
	reject: () => Lang("reject", strings),

	selectApplication: () => Lang("selectApplication", strings),
	selectService: () => Lang("selectService", strings),
	selectDataSet: () => Lang("selectDataSet", strings),
	selectBusinessProcess: () => Lang("selectBusinessProcess", strings),

	name: () => Lang("name", strings),
	applicationName: () => Lang("applicationName", strings),
	type: () => Lang("type", strings),
	status: () => Lang("status", strings),
	city: () => Lang("city", strings),
	company: () => Lang("company", strings),
	riskLevel: () => Lang("riskLevel", strings),
	department: () => Lang("department", strings),
	sapId: () => Lang("sapId", strings),
	hrId: () => Lang("hrId", strings),

	sensitiveData: () => Lang("sensitiveData", strings),
	administrativeRole: () => Lang("administrativeRole", strings),
	reasonForProcessingSensitiveData: () => Lang("reasonForProcessingSensitiveData", strings),
	acceptCheckboxLabel: () => Lang("acceptCheckboxLabel", strings),

	step: () => Lang("step", strings),
	of: () => Lang("of", strings),

	select: (pl: string, en: string, de: string, es: string) => select(pl, en, de, es),

	get: (key: string) => Lang(key, null),
	getDefaultByPrefix: function <T>(obj: T, prefix: keyof T, key?: string) {
		var defaultValue = selectByPrefix(obj, prefix);
		if (defaultValue)
			return defaultValue;
		if (!key)
			return null;
		return Lang(key, null);
	},
	getDefaultByPrefixFromFn: function <T>(obj: T, prefix: keyof T, fn: () => string) {
		var defaultValue = selectByPrefix(obj, prefix);
		if (defaultValue)
			return defaultValue;
		return fn();
	},
	getDefaultByPrefixOrFromStrings: function <T>(obj: T, prefix: keyof T, key?: string) {
		var defaultValue = selectByPrefix(obj, prefix);
		if (defaultValue)
			return defaultValue;
		if (!key)
			return null;
		return Lang(key, strings);
	},
	format: (formatString: string, args: string[]) => format(formatString, args, null),
}